import React from 'react';
import { PatternFormat, PatternFormatProps } from 'react-number-format';

interface CustomProps {
	onChange: (event: { target: { name: string; value: string } }) => void;
	name: string;
}

const PhoneFormat = React.forwardRef<PatternFormatProps, CustomProps>((props, ref) => {
	const { onChange, ...other } = props;

	return (
		<PatternFormat
			{...other}
			inputMode='tel'
			getInputRef={ref}
			onValueChange={(values) => {
				onChange({
					target: {
						name: props.name,
						value: values.value,
					},
				});
			}}
			format='(###) ###-####'
		/>
	);
});

PhoneFormat.displayName = 'PhoneFormat';

export default PhoneFormat;
